import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { FaPhoneAlt, FaEnvelope, FaWhatsapp } from 'react-icons/fa';
import { IoIosArrowDown } from 'react-icons/io';
import { useDispatch } from 'react-redux';
import { setLanguage } from '../../redux/reducers/language/languageSlice';

const languages = [
  { code: 'gb', label: 'English' },
  { code: 'sa', label: 'Arabic' },
  { code: 'fr', label: 'French' },
  { code: 'de', label: 'German' },
];

const TopHeader = () => {
  const { language } = useSelector((state) => state.language);
  const [selectedLang, setSelectedLang] = useState(languages[0]);
  const [open, setOpen] = useState(false);
  const dispatch = useDispatch();

  // Translation dictionary
  const translations = {
    en: {
      phone: "+966 502 114 467",
      email: "info@egccsaudi.com",
      whatsappLabel: "WhatsApp:",
      whatsappNumber: "+966 502 114 467"
    },
    sa: {
      phone: "+966 502 114 467",
      email: "info@egccsaudi.com",
      whatsappLabel: "واتساب:",
      whatsappNumber: "+966 502 114 467"
    },
    fr: {
      phone: "+966 502 114 467",
      email: "info@egccsaudi.com",
      whatsappLabel: "WhatsApp:",
      whatsappNumber: "+966 502 114 467"
    },
    de: {
      phone: "+966 502 114 467",
      email: "info@egccsaudi.com",
      whatsappLabel: "WhatsApp:",
      whatsappNumber: "+966 502 114 467"
    }
  };

  // Get translations for current language (default to English if language not found)
  const t = translations[language] || translations.en;

  const handleSelect = (lang) => {
    setSelectedLang(lang);
    setOpen(false);
    dispatch(setLanguage(lang.code));
  };

  return (
    <div className="bg-black text-white ">
      <div className="container">
        <div className="row align-items-center">
          {/* Contact Info */}
          <div className="col-12 col-md-8 d-flex flex-wrap align-items-center gap-3 mb-2 mb-md-0" style={{ fontSize: '0.8rem' }}>
            <div className="d-flex align-items-center gap-1">
              <FaPhoneAlt className="text-danger" size={12} />
              <span>{t.phone}</span>
            </div>
            <div className="d-flex align-items-center gap-1">
              <FaEnvelope className="text-danger" size={12} />
              <span>{t.email}</span>
            </div>
            <div className="d-flex align-items-center gap-1">
              <FaWhatsapp className="text-danger" size={12} />
              <span>{t.whatsappLabel}</span>
              <span>{t.whatsappNumber}</span>
            </div>
          </div>

          {/* Language Selector */}
          <div className="col-12 col-md-4 d-flex justify-content-md-end position-relative">
            <div className="dropdown">
              <button
                className="btn btn-dark btn-sm d-flex align-items-center gap-1 px-2 py-1 w-100 w-md-auto justify-content-center justify-content-md-start"
                style={{ fontSize: '0.75rem' }}
                onClick={() => setOpen(!open)}
              >
                <img
                  src={`https://flagcdn.com/w40/${selectedLang.code}.png`}
                  alt={selectedLang.label}
                  style={{ height: '12px' }}
                />
                {selectedLang.label}
                <IoIosArrowDown size={12} />
              </button>

              {open && (
                <div className="dropdown-menu show position-absolute mt-1 mr-5 " style={{ minWidth: '140px' }}>
                  {languages.map((lang) => (
                    <button
                      key={lang.code}
                      className="dropdown-item d-flex align-items-center gap-2"
                      onClick={() => handleSelect(lang)}
                    >
                      <img
                        src={`https://flagcdn.com/w40/${lang.code}.png`}
                        alt={lang.label}
                        style={{ height: '12px' }}
                      />
                      {lang.label}
                    </button>
                  ))}
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TopHeader;